const testimonials = [
  {
    name: "Captain James R.",
    location: "Las Olas, Fort Lauderdale, FL",
    rating: 5,
    text: "I'm a yacht captain based out of Fort Lauderdale and I had a charter booking to the Bahamas leaving in three days. One of my crew members discovered his passport had expired two months prior. Fast Passport Center processed his renewal and got it back to us in two days. We made our charter departure from Port Everglades with zero issues. I now require every crew member to maintain a current passport at all times, but Fast Passport Center saved us this time.",
    service: "Passport Renewal",
  },
  {
    name: "The Martinez Family",
    location: "Wilton Manors, Fort Lauderdale, FL",
    rating: 5,
    text: "We booked a Royal Caribbean cruise from Port Everglades for spring break with just under three weeks of notice. I checked our passports two weeks before sailing and discovered my son's passport had expired six months earlier. I had no idea child passports only last five years. Fast Passport Center processed his new passport in four days. We made our cruise embarkation with zero stress. They walked us through every step.",
    service: "Child Passport",
  },
  {
    name: "David K.",
    location: "Downtown Fort Lauderdale, FL",
    rating: 5,
    text: "I had a business meeting in Mexico City that was confirmed with ten days of notice. Pulled out my passport and it had expired three months ago. I was panicking — this was a critical client meeting for a real estate development project. Fast Passport Center got my renewal processed and delivered in five days. I made my flight from FLL to Mexico City and closed the deal. Their team was professional, responsive, and genuinely cared about my timeline.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function FortLauderdaleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Fort Lauderdale Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Las Olas, Wilton Manors, downtown Fort Lauderdale, and Broward County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}